import * as types from "./types";

const INITIAL_STATE = {
  list: [],
  meta: {},
  selectedType: null,
  searchKeyword: null,
  singleSupplementary: {}
};

const supplementriesReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_SUPPLEMENTRIES_RESPONSE:
      return {
        ...state,
        list: action.payload.list,
        meta: action.payload.meta
      };
    case types.SET_SUPPLEMENTARY_FILTERS:
      return {
        ...state,
        searchKeyword: action.payload.searchKeyword,
        selectedType: action.payload.selectedType
      };
    case types.GET_SINGLE_SUPPLEMENTARY_RESPONSE:
      return { ...state, singleSupplementary: action.payload };
    default:
      return state;
  }
};

export default supplementriesReducer;
